import loaded from '@/scripts/helpers/loaded';

loaded(() => {
    document.querySelectorAll('.copy--button__js').forEach(function(element) {
        element.addEventListener('click', function(e) {
            /* Get the text field */
            var copyText = document.getElementById("myInputCopy");

            /* Select the text field */
            copyText.select();
            copyText.setSelectionRange(0, 99999);

            /* For mobile devices */

            /* Copy the text inside the text field */
            navigator.clipboard.writeText(copyText.value);
        });
    });
});
